import React, { useContext, useEffect, useRef, useState } from "react";
import { SideSliderContainer } from "../../ui/SideSliderContainer";
import { useLocation } from "react-router-dom";
import { get } from "../../utils/get";
import styled from "styled-components";
import { LabelText, TitleText } from "../../ui/Text";
import { EditIcon } from "../../assets/svg/EditIcon";
import Input from "../../ui/Input";
import { Field, Formik } from "formik";
import { StatusIcon } from "../../assets/svg/StatusIcon";
import {
  AssignedContainer,
  InputContainer,
  MessageContainer,
  MessageContent,
  TaskCommentContainer,
} from "../timeboard/TaskList";
import Avatar from "../../ui/Avatar";
import { SendButton } from "../../assets/svg/SendButton";
import { AttendeeCard } from "../../components/AttendeeCard";
import { DeleteHook, GetHook } from "../../api/api";
import { INITIATIVES_URL, TASKS_URL } from "../../api/urls";
import numeral from "numeral";
import { DeleteIcon } from "../../assets/svg/DeleteIcon";
import Modal from "../../ui/Modal";
import { AddInitiative } from "./AddInitiative";
import moment from "moment";
import { Clock } from "../../assets/svg/Clock";
import { toast } from "react-toastify";
import Axios from "../../utils/axios";
import { Button } from "../../ui/Button";
import { AuthContext } from "../../context/AuthContext";
import { ReloadPlanSubject } from "../../subjects/ReloadPlanSubject";
import { DropDown } from "../../ui/DropDown";
import useAuth from "../../hooks/useAuth";

interface IProps {
  onClick: () => void;
  isOpen: boolean;
  isEdit?: boolean;
  data?: any;
  reloadData?: any;
  setisModalOpen?: any;
}
const DetailsView = ({
  onClick,
  isOpen,
  isEdit,
  data,
  reloadData,
  setisModalOpen,
}: IProps) => {
  const useOutsideAlerter = (ref, ownerRef) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (!ownerRef.current) {
            onClick();
          }
        }
      }
      document.addEventListener("mousedown", handleClickOutside, true);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside, true);
      };
    }, [ref, ownerRef]);
  };

  const [taskInfoData, setTaskInfoData] = useState({});
  const [deleteURL, setDeleteURL] = useState("null");
  const [updateActual, setUpdateActual] = useState("");
  const [comments, setComments] = useState<any>([]);
  const location = useLocation();
  const SliderRef = useRef(null);
  const ownerRef = useRef(null);
  const formRef: any = useRef<any>(null);
  useOutsideAlerter(SliderRef, ownerRef);
  const isInitiative = get(location, "pathname").includes("initiatives");
  const url = isInitiative ? `${INITIATIVES_URL}` : `${TASKS_URL}`;
  const auth = useAuth();
  const { isManager } = auth;
  const { user } = get(auth, "authState");

  const { data: comment, reload } = GetHook(
    get(data, "[0]id") ? `${url}/${get(data, "[0]id")}/comment` : "null"
  );
  const {
    data: deleteRes,
    error: deleteError,
    pending: deletePending,
  } = DeleteHook(deleteURL);

  const getColor = (priority) => {
    switch (true) {
      case priority === "high":
        return "#D51067";
      case priority === "medium" || priority === "active":
        return "#EDBC0C";
      default:
        return "#4BD041";
    }
  };

  useEffect(() => {
    setComments(comment);
    return () => {};
  }, [comment]);

  useEffect(() => {
    if (isOpen) {
      // @ts-ignore
      SliderRef.current?.focus();
      let status =
        get(data, "[0]status") === "complete"
          ? {
              label: "Complete",
              value: "complete",
              icon: <StatusIcon color={getColor("complete")} />,
            }
          : {
              label: "In Progress",
              value: "active",
              icon: <StatusIcon />,
            };
      formRef.current?.setFieldValue("status", status);
    }
    return () => {};
  }, [isOpen]);
  useEffect(() => {
    if (deleteRes && !deleteError && !deletePending) {
      toast.success("Deleted successfully!");
      reloadData();
      onClick();
    } else if (deleteRes && deleteError && !deletePending) {
      toast.error(`Delete failed: ${get(deleteError, "data.message")}`);
    }
    return () => {};
  }, [deleteRes, deleteError, deletePending]);

  const handleUpdateActaul = (values) => {
    const payload =
      updateActual === "length"
        ? { actual_length: get(values, "actual_length") }
        : { actual_amount: get(values, "actual_amount") };

    Axios.put(`${url}/${get(data[0], "id")}`, payload)
      .then((res) => {
        toast.success(`${get(data[0], "name")} Actual budget updated`);
        setUpdateActual("");
        reload(get(location, "key"));
        onClick();
        ReloadPlanSubject.next(true);
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  const handleComment = (values, resetForm) => {
    const payload = {
      source_user_id: get(user, "id"),
      comment: get(values, "comment"),
    };

    Axios.post(`${INITIATIVES_URL}/${get(data[0], "id")}/comment`, payload)
      .then((res) => {
        toast.success("Comment posted");
        resetForm({ comment: "" });
        reload(get(location, "key"));
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  const handleStatusUpdate = (values, resetForm) => {
    const putUrl = isInitiative
      ? `${url}/${get(data[0], "id")}`
      : `${TASKS_URL}/${get(data[0], "id")}/owner/${get(user, "id")}`;
    const payload = {
      status: get(values, "value"),
    };

    Axios.put(putUrl, payload)
      .then((res) => {
        toast.success("status updated to " + get(values, "value"));
        setUpdateActual("");
        onClick();
        ReloadPlanSubject.next(true);
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  const taskStatus = get(data[0], "owners").filter(
    (owner) => owner.owner_id === get(user, "id")
  );
  return (
    <Formik
      innerRef={formRef}
      initialValues={{ status: "" }}
      onSubmit={() => console.log()}
    >
      {({ values, resetForm }) => (
        <SideSliderContainer maxWidth={"35em"} tabIndex={0} ref={SliderRef}>
          <Container>
            <Header>
              <Header>
                <TitleText>{get(data, "[0]name", "")}</TitleText>
              </Header>
              {isInitiative && isManager() ? (
                <div>
                  <LabelText
                    color="#01A8CE"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setisModalOpen(true);
                      onClick();
                    }}
                  >
                    <EditIcon /> <span>Edit</span>
                  </LabelText>
                  <LabelText
                    color="#EC6465"
                    style={{ cursor: "pointer", marginLeft: "1em" }}
                    onClick={() =>
                      setDeleteURL(
                        `${isInitiative ? INITIATIVES_URL : TASKS_URL}/${get(
                          data,
                          "[0].id"
                        )}`
                      )
                    }
                  >
                    <DeleteIcon /> <span>Delete</span>
                  </LabelText>
                </div>
              ) : null}
            </Header>
            <Description>
              <LabelText>Created By</LabelText>
              <TitleText>
                {get(data, "[0]created_by_user.names", "-")} ,
                <LabelText
                style={{
                  display: "inline-block",
                  paddingLeft: "1em",
                  fontSize: "12px",
                }}
                >
                {moment(get(data, "[0]created_at", "")).format(
                    "DD MMM YYYY, h a"
                  )}
                  </LabelText>
              </TitleText>
            </Description>
            <Description>
              <LabelText>Description</LabelText>
              <TitleText>{get(data, "[0]notes", "")}</TitleText>
            </Description>

            <Highlight style={{ gridColumn: "1 /span 2" }}>
              <LabelText>{isInitiative ? "Objective" : "Initiative"}</LabelText>
              <Highlighted>
                <TitleText>
                  {isInitiative
                    ? get(data, "[0]objective.name")
                    : get(data, "[0]initiative.name")}
                </TitleText>
              </Highlighted>
            </Highlight>
            <Highlight>
              <LabelText>Priority</LabelText>
              <Highlighted>
                <StatusIcon color={getColor(get(data, "[0]priority"))} />{" "}
                <TitleText>{get(data, "[0]priority")}</TitleText>
              </Highlighted>
            </Highlight>

            {isInitiative ? (
              <Field
                name="status"
                component={DropDown}
                height="2.85em"
                options={
                  get(data[0], "owners") &&
                  get(data[0], "owners").filter(
                    (owner) => owner.id === get(user, "id")
                  )
                    ? [
                        {
                          label: "In Progress",
                          value: "active",
                          icon: <StatusIcon />,
                        },
                        {
                          label: "Complete",
                          value: "complete",
                          icon: <StatusIcon color={getColor("complete")} />,
                        },
                      ]
                    : [{ label: "Approved", value: "Approved" }]
                }
                dropdownLabel="Status"
                width="90%"
                onChange={(values) => handleStatusUpdate(values, resetForm)}
                backgroundColor="#f5f6fb"
              />
            ) : (
              <Highlight
                style={{ cursor: "pointer" }}
                onClick={() => setUpdateActual("status")}
              >
                <LabelText>Status</LabelText>
                <Highlighted>
                  <StatusIcon
                    color={
                      isInitiative
                        ? getColor(get(data, "[0]status"))
                        : getColor(get(taskStatus[0], "status"))
                    }
                  />{" "}
                  <TitleText>
                    {isInitiative
                      ? get(data, "[0]status")
                      : get(taskStatus[0], "status")}
                  </TitleText>
                </Highlighted>
              </Highlight>
            )}

            <LabelText>{isInitiative ? "Dates" : "Due Date"}</LabelText>
            {isInitiative ? (
              get(data, "[0]periods").map((date, index) => (
                <DateItem key={index}>
                  <CountItem>{index + 1}</CountItem>
                  <TitleText>
                    {moment(date?.start_date).format("DD-MMMM-YYYY")}
                  </TitleText>
                  <LabelText>to</LabelText>
                  <TitleText>
                    {moment(date?.end_date).format("DD-MMMM-YYYY")}
                  </TitleText>
                </DateItem>
              ))
            ) : (
              <DateItem>
                <CountItem>
                  <Clock />
                </CountItem>
                <TitleText>
                  {moment(data[0]?.due_date).format("DD-MMMM-YYYY")}
                </TitleText>
              </DateItem>
            )}

            <LabelText>Cost</LabelText>
            <Card>
              <Title>Budget</Title>
              <TitleText>
                KSH {numeral(get(data[0], "budget")).format("0,0.00")}
              </TitleText>
            </Card>
            {updateActual === "budget" ? (
              <UpdateInputComponent>
                <Field
                  name="actual_amount"
                  label="Actual"
                  component={Input}
                  width="80%"
                  placeholder="Update actual budget"
                />
                <SaveButton
                  text="save"
                  onClick={() => handleUpdateActaul(values)}
                />
              </UpdateInputComponent>
            ) : (
              <Card>
                <TaskCardHeader>
                  <Title>Actual</Title>
                  {isInitiative && (
                    <LabelText
                      color="#01A8CE"
                      style={{ cursor: "pointer" }}
                      onClick={() => setUpdateActual("budget")}
                    >
                      <EditIcon /> Update
                    </LabelText>
                  )}
                </TaskCardHeader>
                <TitleText>
                  KSH {numeral(get(data, "[0]actual_amount")).format("0,0.00")}{" "}
                </TitleText>
              </Card>
            )}

            <LabelText>Time</LabelText>
            <Card>
              <Title>Budget</Title>
              <TitleText>
                {get(data[0], "length")}{" "}
                {get(data[0], "length_type") &&
                  get(data[0], "length_type").toUpperCase()}
              </TitleText>
            </Card>
            {updateActual === "length" ? (
              <UpdateInputComponent>
                <Field
                  name="actual_length"
                  label="Actual"
                  component={Input}
                  width="80%"
                  placeholder="Update actual length"
                />
                <SaveButton
                  text="save"
                  onClick={() => handleUpdateActaul(values)}
                />
              </UpdateInputComponent>
            ) : (
              <Card>
                <TaskCardHeader>
                  <Title>Actual</Title>
                  {isInitiative && (
                    <LabelText
                      color="#01A8CE"
                      style={{ cursor: "pointer" }}
                      onClick={() => setUpdateActual("length")}
                    >
                      <EditIcon /> Update
                    </LabelText>
                  )}
                </TaskCardHeader>
                <TitleText>
                  {get(data, "[0]actual_length")}{" "}
                  {get(data, "[0]length_type") &&
                    get(data, "[0]length_type").toUpperCase()}
                </TitleText>
              </Card>
            )}
            <AssignedContainer>
              <LabelText>Owners</LabelText>
              {get(data[0], "owners") &&
                get(data[0], "owners").map((owner, index) => {
                  return <AttendeeCard key={index} data={owner} />;
                })}
            </AssignedContainer>
            <TaskCommentContainer>
              <LabelText>Comments</LabelText>
              {comments.map((comment) => {
                return (
                  <MessageContainer>
                    <Avatar
                      url={
                        comment.source_user.avatar_url ||
                        `https://ui-avatars.com/api/?name=${comment?.source_user.names}`
                      }
                    />
                    <MessageContent>
                      <TitleText>{comment.source_user.names}</TitleText>
                      <Comment>{comment.comment}</Comment>
                    </MessageContent>
                  </MessageContainer>
                );
              })}
            </TaskCommentContainer>
            <InputContainer>
              <Field
                name="comment"
                component={Input}
                width="99%"
                placeholder="Write your comment"
                height="28px"
              />
              <Icon onClick={() => handleComment(values, resetForm)}>
                <SendButton />
              </Icon>
            </InputContainer>
          </Container>
        </SideSliderContainer>
      )}
    </Formik>
  );
};

export default DetailsView;

const Container = styled.div`
  background-color: #fff;
  display: grid;
  grid-column-gap: 3em;
  row-gap: 0.4em;
  grid-template-columns: 1fr 1fr;
  border-radius: 10px;

  ${LabelText} {
    align-items: center;
    grid-column: 1 / span 2;
    padding-bottom: 1em;
  }
`;

const Header = styled.div`
  display: flex;
  grid-column: 1 / span 2;
  padding-bottom: 1em;
  justify-content: space-between;
  ${TitleText} {
    font-size: normal;
    font-weight: 600;
  }
  ${LabelText} {
    align-items: center;
    grid-column: 1 / span 2;
  }
`;
const Description = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / span 2;
  padding-bottom: 1em;
  ${TitleText} {
    font-size: 12;
    font-weight: normal;
  }
`;

const Highlight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: baseline;
  margin-bottom: 1em;
  ${LabelText} {
    align-items: center;
    grid-column: 1 / span 2;
    padding-bottom: 1.6em;
  }
`;

const Highlighted = styled.span`
  display: flex;
  align-items: center;
  background-color: #f5f6fb;
  height: 0.71em;
  padding: 1em;
  border-radius: 0.5em;
  ${TitleText} {
    padding-left: 1em;
  }
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f6fb;
  padding: 1.5em;
  margin-bottom: 1em;
  border-radius: 1em;
  ${TitleText} {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
  }
`;

const Title = styled.h5`
  margin: 0;
  font-weight: normal;
  font-size: 14px;
  color: #214160;
  opacity: 0.5;
  margin-bottom: 1em;
`;

const TaskCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Comment = styled.h2`
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  color: #214160;
  margin: 0;
  padding: 0;
  margin-block-end: 0;
  margin-block-start: 0;
`;

const Icon = styled.span`
  position: absolute;
  padding: 15px;
  color: rgb(49, 0, 128);
  width: 70px;
  top: 18%;
  left: 95%;
`;

const DateItem = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 1.75fr 0.5fr 2fr;
  grid-column: 1 / span 2;
  align-items: center;
  margin-bottom: 1em;
  ${LabelText} {
    grid-column: 3;
    padding: 0;
  }
`;
const CountItem = styled.span`
  font-weight: semi-bold;
  font-size: 1.125em;
  color: #01A8CE;
  padding: 0.4em 0.6em;
  margin-right: 0.5em;
  align-items: center;
  border-radius: 25%;
  width: fit-content;
  border: 1px solid rgba(76, 92, 251, 0.1);
`;

const UpdateInputComponent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const SaveButton = styled(Button)`
  margin-top: 2em;
  padding: 0.85em 1em;
`;
